(() => {
  if (customElements.get('rp-variant-options')) return;
  customElements.define('rp-variant-options', class extends HTMLElement {
    connectedCallback() {
      this.pricing = this.parentElement.querySelector('rp-custom-pricing');
      if (!this.pricing) return;
      this.abort = new AbortController();
      this.boundGroups = new WeakSet();
      this.ownerDocument.addEventListener('pointerdown', e => {
        this.pricing.querySelectorAll('[data-rp-disclosure]').forEach(group => {
          if (!group.contains(e.target)) group.querySelector('.custom-option-toggle')?.setAttribute('aria-expanded', 'false');
        });
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.pricing, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      this.refresh();
    }
    refresh() {
      this.pricing.querySelectorAll('.custom-option-dropdown,.extra-option-dropdown').forEach((group, index) => {
        const list = group.querySelector('.custom-option-list');
        let toggle = group.querySelector('.custom-option-toggle');
        if (!list || !toggle) return;
        if (!this.boundGroups.has(group)) {
          this.boundGroups.add(group);
          group.dataset.rpDisclosure = '';
          const label = toggle.querySelector('.custom-option-label')?.textContent.trim() || '';
          group.dataset.rpSize = String(/size|dimension|尺寸/i.test(label));
          if (toggle.tagName !== 'BUTTON') {
            const button = document.createElement('button');
            button.className = toggle.className;
            while (toggle.firstChild) button.append(toggle.firstChild);
            toggle.replaceWith(button); toggle = button;
          }
          toggle.type = 'button';
          list.id = `${this.pricing.closest('product-info').id}-options-${index}`;
          toggle.setAttribute('aria-controls', list.id);
          toggle.setAttribute('aria-expanded', 'false');
          if (!toggle.querySelector('.custom-option-current')) {
            const current = document.createElement('span');
            current.className = 'custom-option-current'; toggle.append(current);
          }
          toggle.addEventListener('click', () => {
            const open = toggle.getAttribute('aria-expanded') !== 'true';
            this.pricing.querySelectorAll('[data-rp-disclosure]>.custom-option-toggle').forEach(other => {
              other.setAttribute('aria-expanded', String(other === toggle && open));
            });
          }, { signal: this.abort.signal });
          group.addEventListener('keydown', e => {
            if (e.key === 'Escape') { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
          }, { signal: this.abort.signal });
          list.addEventListener('click', e => {
            const row = e.target.closest('.custom-option-item');
            if (row && !row.classList.contains('disabled')) {
              toggle.setAttribute('aria-expanded', 'false'); toggle.focus({ preventScroll: true });
            }
          }, { signal: this.abort.signal });
        }
        const selected = list.querySelector('.is-active');
        const current = toggle.querySelector('.custom-option-current');
        const text = selected?.textContent.trim() || '';
        if (current.textContent !== text) current.textContent = text;
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); }
  });
})();
